module.exports = require("./ku.d.ts");